let swiperInstance;

// Function to initialize Swiper
function initSwiper(swiperContainer) {
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
  }

  swiperInstance = new Swiper(swiperContainer, {
    slidesPerView: 2.5,
    spaceBetween: 10,
    freeMode: true,
  });

  swiperInstance.update();
}

console.log('in1');

// Function to check if the #predictive-search div is visible
function isSearchVisible() {
  const predictiveSearchDiv = document.getElementById('predictive-search');
  return predictiveSearchDiv && predictiveSearchDiv.style.display === 'block';
}

function initSearchScript() {
  if (!isSearchVisible()) return;

  const resultsWrapper = document.getElementById('predictive-search-results');
  if (!resultsWrapper) return;

  const categories = Array.from(resultsWrapper.querySelectorAll('.predictive-search__result-group'));
  if (categories.length === 0) return;

  let activeCategoryIndex = 0;
  let activeItemIndex = -1;

  function getActiveCategoryItems() {
    return Array.from(categories[activeCategoryIndex].querySelectorAll('.predictive-search__list-item'));
  }

  function clearAllActive() {
    categories.forEach((category) => {
      const items = Array.from(category.querySelectorAll('.predictive-search__list-item'));
      items.forEach((item) => item.classList.remove('active-pd'));
    });
  }

  function setActiveItem(index) {
    const items = getActiveCategoryItems();
    clearAllActive();
    if (index >= 0 && index < items.length) {
      items[index].classList.add('active-pd');
      items[index].scrollIntoView({ block: 'nearest' });
    }
  }

  function setActiveCategory(index) {
    activeCategoryIndex = (index + categories.length) % categories.length;
    activeItemIndex = -1;
    setActiveItem(activeItemIndex);
  }

  function handleKeyDown(e) {
    const items = getActiveCategoryItems();

    if (e.key === 'ArrowDown') {
      if (items.length && activeItemIndex < items.length - 1) {
        activeItemIndex++;
        setActiveItem(activeItemIndex);
      } else {
        setActiveCategory(activeCategoryIndex + 1);
      }
      e.preventDefault();
    } else if (e.key === 'ArrowUp') {
      if (activeItemIndex > 0) {
        activeItemIndex--;
        setActiveItem(activeItemIndex);
      } else {
        setActiveCategory(activeCategoryIndex - 1);
      }
      e.preventDefault();
    } else if (e.key === 'ArrowLeft') {
      if (activeItemIndex > 0) {
        activeItemIndex--;
        setActiveItem(activeItemIndex);
      }
      e.preventDefault();
    } else if (e.key === 'ArrowRight') {
      if (activeItemIndex < items.length - 1) {
        activeItemIndex++;
        setActiveItem(activeItemIndex);
      }
      e.preventDefault();
    } else if (e.key === 'Enter' && activeItemIndex !== -1) {
      const activeItem = items[activeItemIndex].querySelector('a');
      const activeItemText = items[activeItemIndex].textContent.trim();

      // Set the search bar value to the selected item text
      const searchBox = document.getElementById('Search');
      searchBox.value = activeItemText;

      if (activeItem) {
        // Modify the link to include the search term as a query parameter
        const currentUrl = new URL(activeItem.href);
        currentUrl.searchParams.set('search_term', activeItemText);
        window.location.href = currentUrl.toString();  // Redirect to the updated URL
        e.preventDefault();
      }
    }
  }

  const searchBox = document.getElementById('Search');
  searchBox.addEventListener('keydown', handleKeyDown);

  searchBox.addEventListener('blur', () => {
    activeItemIndex = -1;
    clearAllActive();
  });

  resultsWrapper.addEventListener('click', (e) => {
    const clickedItem = e.target.closest('.predictive-search__list-item');
    if (clickedItem) {
      const clickedItemText = clickedItem.textContent.trim();
      const searchBox = document.getElementById('Search');
      searchBox.value = clickedItemText;
    }
  });
}

// PredictiveSearch class definition
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.predictiveSearchResults.addEventListener('click', (event) => {
      const clickedAnchor = event.target.closest('a');
      if (clickedAnchor) {
        const searchTerm = clickedAnchor.textContent.trim();
        const url = clickedAnchor.getAttribute('href');
      }
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();

        const swiperContainer = this.predictiveSearchResults.querySelector('.predictive-search-swiper');
        if (swiperContainer) {
          initSwiper(swiperContainer);
        }

        initSearchScript();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
